import { Component, OnChanges, SimpleChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import {StringUtils} from '../../utils/string-utils';
import {UnitConversionUtils} from '../../configurator/unit-conversion-utils';
import {SureFlowUnitData} from '../../model/sure-flow-unit-data';
import {SureFlowRatingCoilRequest} from '../../model/sure-flow-rating-coil-request';
import {GuruEntity} from '../../model/guru-entity';
import {FormsModule} from '@angular/forms';


@Component({
    selector: 'app-sure-flow-performance-coil-input',
    templateUrl: './sure-flow-performance-coil-input.component.html',
    styleUrls: ['./sure-flow-performance-coil-input.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule]
})
export class SureFlowPerformanceCoilInputComponent implements OnChanges {

  readonly fieldLabel = input.required<string>();
  readonly coilRequestInput = input.required<SureFlowRatingCoilRequest>({ alias: 'coilRequest' });
  readonly unitDataInput = input<SureFlowUnitData>(undefined!, { alias: 'unitData' });
  readonly metricInput = input.required<boolean>();
  readonly inputChanged = output<GuruEntity | undefined>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['metricInput'] && !changes['metricInput'].firstChange) {
      this.convertConditionalValues();
    }
  }

  private convertConditionalValues(): void {
    this.coilRequestInput().enteringDryBulb = this.convertAndRoundTemperature(this.coilRequestInput().enteringDryBulb);
    this.coilRequestInput().enteringFluidTemperature = this.convertAndRoundTemperature(this.coilRequestInput().enteringFluidTemperature);
    if (this.coilRequestInput().isCooling) {
      this.coilRequestInput().enteringWetBulb = this.convertAndRoundTemperature(this.coilRequestInput().enteringWetBulb);
    }
  }

  private convertAndRoundTemperature(input: number): number {
    if (StringUtils.isEmptyNumericValue(input)) {
      return undefined!;
    }
    return this.round(UnitConversionUtils.convertTemperatureValue(input, this.metricInput()), 3);
  }

  private round(value: string, digits: number): number {
    const numericValue = +value;
    const roundedValue = numericValue.toFixed(digits);
    return +roundedValue;
  }

  inputValueChange(selectionName: string, value: string): void {
    const entity: GuruEntity = new GuruEntity();
    entity.Name = selectionName;
    entity.Value = value;
    this.inputChanged.emit(entity);
  }

  nonRatedValueChange(): void {
    this.inputChanged.emit(undefined);
  }

  getTemperatureUnits(): string {
    return UnitConversionUtils.getTemperatureUnits(this.metricInput());
  }

  getFlowRateUnits(): string {
    return UnitConversionUtils.getFlowRateUnits(this.metricInput());
  }

  showGlycolPercent(): boolean {
    return StringUtils.equalsIgnoreCase(this.coilRequestInput().fluidType, 'E') || StringUtils.equalsIgnoreCase(this.coilRequestInput().fluidType, 'P');
  }

  getCapacityUnits(): string {
    return UnitConversionUtils.getCapacityUnits(this.metricInput());
  }

}
